<template>
  <div class="effect-analysis">
    <!-- 新版效果分析 -->
    <!-- <effect-analysis-x></effect-analysis-x> -->

    <div class="top-box box-shadow">
      <div v-if="!showSend">
        <div class="nav-box">
          <i class="iconfont iconicon_fanhui" style="color:#999;margin-right:4px"></i>
          <span class="go-back" @click="goBack">返回列表</span>
          <span class="division"></span>
          <span class="title">营销效果分析</span>
          <span></span>
          <el-tooltip
            class="item"
            effect="light"
            :content="roiTip"
            placement="bottom"
          >
            <span class="question_icon">?</span> </el-tooltip
          ><span style="margin-left:4px" class="roi">ROI(投入产出比)：</span>
          <span class="num">{{ roi }}</span>
          <el-input
            size="small"
            v-if="updateState"
            type="text"
            v-model="unitPrice"
            class="price-input"
          ></el-input
          ><span v-if="updateState">元/条</span>
          <span
            class="update"
            @click="updateROI"
            >{{ updateState ? "保存" : "修改" }}</span
          >
        </div>
        <!-- 营销效果分析页 第二种类型 -->
        <div class="effect-content-x" v-if="typeEffect == 2 || typeEffect == 3">
          <div class="tab-line-com">
            <div
              class="tab-item"
              @click="handleSwitch(1)"
              :class="{ active: tabIndex == '1' }"
              :style="{
                color: tabIndex == '1' ? globalBG : '',
                'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
              }"
            >
              效果分析
              <span></span>
            </div>
            <div
              class="tab-item"
              v-if="typeEffect == 2"
              @click="handleSwitch(5)"
              :class="{ active: tabIndex == '5' }"
              :style="{
                color: tabIndex == '5' ? globalBG : '',
                'border-top': tabIndex == '5' ? '2px solid ' + globalBG : '',
              }"
            >
              订单详情
              <span></span>
            </div>
            <div
              v-if="typeEffect == 3"
              class="tab-item"
              @click="handleSwitch(2)"
              :class="{ active: tabIndex == '2' }"
              :style="{
                color: tabIndex == '2' ? globalBG : '',
                'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
              }"
            >
              活动对比
              <span></span>
            </div>
            <div
              class="tab-item"
              @click="handleSwitch(3)"
              :class="{ active: tabIndex == '3' }"
              :style="{
                color: tabIndex == '3' ? globalBG : '',
                'border-top': tabIndex == '3' ? '2px solid ' + globalBG : '',
              }"
            >
              客户详情
              <span></span>
            </div>
            <div
              class="tab-item"
              @click="handleSwitch(4)"
              :class="{ active: tabIndex == '4' }"
              :style="{
                color: tabIndex == '4' ? globalBG : '',
                'border-top': tabIndex == '4' ? '2px solid ' + globalBG : '',
              }"
            >
              商品详情
              <span></span>
            </div>
          </div>
          <!-- 短信信息内容 -->
          <div class="top-content" v-if="typeEffect == 2 && tabIndex == 1">
            <div class="tip-box">
              <i class="el-icon-warning warning-icon"></i>
              <span
                >营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供，无法查看到会员明细数据</span
              >
            </div>
            <div class="info-box">
              <div>
                <span>状态：</span>
                <span style="margin-right: 50px">已发送</span>

                <span>会员总数：</span>
                <span :style="{ color: globalBG }">{{
                  effectObj.shopBuyerNum
                }}</span>
                <span style="margin-right: 50px">人</span>

                <span>短信费用：</span>
                <span :style="{ color: globalBG }">{{
                  effectObj.totalPrice
                }}</span>
                <span>条</span>
              </div>
              <div>
                <span>短信内容</span>
                <span>{{ effectObj.content }}</span>
              </div>
            </div>
          </div>

          <!-- 效果分析 -->
          <div class="tab1-box" v-if="tabIndex == 1">
            <!-- 活动详情 -->
            <div v-if="typeEffect == 3" class="activity-content">
              <div class="title comment-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>活动详情</span>
              </div>
              <div class="data-content">
                <div class="data-item">
                  <div class="data-label">任务名称：</div>
                  <div class="data-value">{{ taskObj.taskName }}</div>
                </div>
                <div class="data-item">
                  <div class="data-label">创建时间：</div>
                  <div class="data-value">{{ taskObj.creationTime }}</div>
                </div>
                <div class="data-item">
                  <div class="data-label">执行完成时间：</div>
                  <div class="data-value">
                    {{ taskObj.expectedCompletionTime }}
                  </div>
                </div>
                <div class="data-item">
                  <div class="data-label">分析对象：</div>
                  <div class="data-value">
                    <div
                      v-for="(item, index) in taskObj.smsTitleList"
                      :key="index"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 客户数据 -->
            <div
              class="search-box"
              style="padding-top: 20px"
              v-if="typeEffect == 2"
            >
              <span>统计时间：</span>
              <el-select
                v-model="formData.type"
                placeholder="请选择"
                style="width: 140px; margin-right: 12px; vertical-align: top"
                @change="switchType"
              >
                <el-option
                  v-for="item in timeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData.startTime"
                  type="date"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData.endTime"
                  type="date"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime1()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
              <el-button
                type="primary"
                style="margin-left: 20px"
                @click="getEffectDataOthers"
                >查询</el-button
              >
              <el-button @click="resetDataOthers">重置</el-button>
            </div>
            <div class="customer-data">
              <div class="customer-item">
                <div class="customer-title">
                  <span
                    class="division"
                    :style="{ background: globalBG }"
                  ></span>
                  <span>触达分析</span>
                </div>
                <div class="customer-content">
                  <div
                    v-for="(
                      item, index
                    ) in effectAnalysisData.targetCustomerMap"
                    :key="index"
                  >
                    {{ item.name }}{{ item.value != null ? item.value : "--"
                    }}{{ item.unit }}
                  </div>
                </div>
                <div class="select-box" v-if="!isHideSSend">
                  <el-select
                    v-model="selectForm.x1"
                    placeholder="发送短信"
                    style="width: 260px"
                  >
                    <el-option
                      v-for="item in targetCMList"
                      @click.native="handleClick(item)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!(item.num > 0)"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="customer-item" v-if="!effectObj.isOfficial">
                <div class="customer-title">
                  <span
                    class="division"
                    :style="{ background: globalBG }"
                  ></span>
                  <span>短链接效果</span>
                </div>
                <div class="customer-content">
                  <div
                    v-for="(
                      item, index
                    ) in effectAnalysisData.shortLinkAccessMap"
                    :key="index"
                  >
                    {{ item.name }}{{ item.value != null ? item.value : "--"
                    }}{{ item.unit }}
                  </div>
                </div>
                <div class="select-box" v-if="!isHideSSend">
                  <el-select
                    v-model="selectForm.x2"
                    placeholder="发送短信"
                    style="width: 260px"
                  >
                    <el-option
                      v-for="item in shortLinkList"
                      @click.native="handleClick(item)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!(item.num > 0)"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="customer-item">
                <div class="customer-title">
                  <span
                    class="division"
                    :style="{ background: globalBG }"
                  ></span>
                  <span>下单分析</span>
                </div>
                <div class="customer-content">
                  <div
                    v-for="(item, index) in effectAnalysisData.takeOrderMap"
                    :key="index"
                  >
                    {{ item.name }}{{ item.value != null ? item.value : "--"
                    }}{{ item.unit }}
                  </div>
                </div>
                <div class="select-box" v-if="!isHideSSend">
                  <el-select
                    v-model="selectForm.x3"
                    placeholder="发送短信"
                    style="width: 260px"
                  >
                    <el-option
                      v-for="item in takeOrderList"
                      @click.native="handleClick(item)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!(item.num > 0)"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="customer-item">
                <div class="customer-title">
                  <span
                    class="division"
                    :style="{ background: globalBG }"
                  ></span>
                  <span>付款分析</span>
                </div>
                <div class="customer-content">
                  <div
                    v-for="(item, index) in effectAnalysisData.successMap"
                    :key="index"
                  >
                    {{ item.name }}{{ item.value != null ? item.value : "--"
                    }}{{ item.unit }}
                  </div>
                </div>
                <div class="select-box" v-if="!isHideSSend">
                  <el-select
                    v-model="selectForm.x4"
                    placeholder="发送短信"
                    style="width: 260px"
                  >
                    <el-option
                      v-for="item in payAList"
                      @click.native="handleClick(item)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!(item.num > 0)"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="customer-item">
                <div class="customer-title">
                  <span
                    class="division"
                    :style="{ background: globalBG }"
                  ></span>
                  <span>意向购买分析</span>
                </div>
                <div class="customer-content">
                  <div
                    v-for="(item, index) in effectAnalysisData.potentialMap"
                    :key="index"
                  >
                    {{ item.name }}{{ item.value != null ? item.value : "--"
                    }}{{ item.unit }}
                  </div>
                </div>
                <div class="select-box" v-if="!isHideSSend">
                  <el-select
                    v-model="selectForm.x5"
                    placeholder="发送短信"
                    style="width: 260px"
                  >
                    <el-option
                      v-for="item in potentialList"
                      @click.native="handleClick(item)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!(item.num > 0)"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- 趋势分析，图表 -->
            <div style="margin-top: 30px">
              <p>趋势分析</p>
              <my-echarts
                v-if="trendingList.length > 0"
                :trendingList="trendingList"
              ></my-echarts>
            </div>
          </div>
          <!-- 活动对比 -->
          <div class="tab2-box" v-if="tabIndex == 2">
            <div class="table-box">
              <el-table
                ref="activityTable"
                :data="activityData"
                :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
                tooltip-effect="light"
                style="width: 100%; border: 1px solid #eee"
                stripe
                v-loading="tableLoading"
              >
                <el-table-column
                  label="活动主题"
                  prop="smsTitle"
                  width="300px"
                ></el-table-column>
                <el-table-column label="ROI" prop="roiRate"></el-table-column>
                <el-table-column label="目标客户数/发送成功客户数">
                  <template slot-scope="scope">
                    {{ scope.row.subNumberCount }}/{{
                      scope.row.validNumberCount
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="成交客户数/成交金额（元)">
                  <template slot-scope="scope">
                    {{ scope.row.successCustomerCount }}/{{
                      scope.row.successMoneyCount
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="成交响应率"
                  prop="successResponseRate"
                ></el-table-column>
                <el-table-column label="意向客户数/未付款订单">
                  <template slot-scope="scope">
                    {{ scope.row.intentionalCustomerCount }}/{{
                      scope.row.noPaymentOrderCount
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="意向响应率"
                  prop="intentionalResponseRate"
                ></el-table-column>
              </el-table>
            </div>
            <!-- 对比分析 -->
            <div class="comp-analysis">
              <div class="title comment-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>对比分析</span>
              </div>
              <div class="tab-line-com">
                <div
                  class="tab-item"
                  @click="handleCompSwitch(1)"
                  :class="{ active: tabCompIndex == '1' }"
                  :style="{
                    color: tabCompIndex == '1' ? globalBG : '',
                    'border-top':
                      tabCompIndex == '1' ? '2px solid ' + globalBG : '',
                  }"
                >
                  客户数量分析
                  <span></span>
                </div>
                <div
                  class="tab-item"
                  @click="handleCompSwitch(2)"
                  :class="{ active: tabCompIndex == '2' }"
                  :style="{
                    color: tabCompIndex == '2' ? globalBG : '',
                    'border-top':
                      tabCompIndex == '2' ? '2px solid ' + globalBG : '',
                  }"
                >
                  订单金额分析
                  <span></span>
                </div>
                <div
                  class="tab-item"
                  @click="handleCompSwitch(3)"
                  :class="{ active: tabCompIndex == '3' }"
                  :style="{
                    color: tabCompIndex == '3' ? globalBG : '',
                    'border-top':
                      tabCompIndex == '3' ? '2px solid ' + globalBG : '',
                  }"
                >
                  商品数据分析
                  <span></span>
                </div>
                <div
                  class="tab-item"
                  @click="handleCompSwitch(4)"
                  :class="{ active: tabCompIndex == '4' }"
                  :style="{
                    color: tabCompIndex == '4' ? globalBG : '',
                    'border-top':
                      tabCompIndex == '4' ? '2px solid ' + globalBG : '',
                  }"
                >
                  响应率分析
                  <span></span>
                </div>
              </div>
              <div class="echarts-box" style="margin-top: 30px">
                <echarts-common :echartsData="echartsData"></echarts-common>
              </div>
            </div>
          </div>
          <!-- 客户详情 -->
          <div class="tab3-box">
            <search-table
              v-if="tabIndex == 3"
              :tableType="tableType1"
              :flagTotal="typeEffect == '3'"
              :taskId="taskId"
              :batchId="batchId"
            ></search-table>
            <!-- 客户详情 -->
            <search-table
              v-if="tabIndex == 4"
              :tableType="tableType2"
              :flagTotal="typeEffect == '3'"
              :taskId="taskId"
              :batchId="batchId"
            ></search-table>
            <!-- 商品详情 -->
            <search-table
              v-if="tabIndex == 5"
              :tableType="tableType3"
              :batchId="batchId"
            ></search-table>
            <!-- 订单详情 -->
          </div>
        </div>
        <!-- end -->
        <div class="top-content" v-if="typeEffect == 1 || typeEffect == 5">
          <div class="tip-box">
            <i class="el-icon-warning warning-icon"></i>
            <span
              >营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供，无法查看到会员明细数据</span
            >
          </div>
          <div class="info-box" v-if="typeEffect == 1">
            <div>
              <span>状态：</span>
              <span style="margin-right: 50px">
                <span v-if="!homeJump">{{
                  effectObj.sendStatus | showStatusStr
                }}</span>
                <span v-else>{{
                  homePageData.sendStatus | showStatusStr
                }}</span>

                <!-- <span v-if="effectObj.sendStatus == 3">审核通过</span>
                <span v-if="effectObj.sendStatus == 4">审核未通过</span>
                <span v-if="effectObj.sendStatus == 5">已取消</span>
                <span v-if="effectObj.sendStatus == 100">发送中</span>
                <span v-if="effectObj.sendStatus == 101">已发送</span>
                <span v-if="effectObj.sendStatus == 102">发送失败</span> -->
              </span>

              <span>会员总数：</span>
              <span :style="{ color: globalBG }" v-if="targetCustomerMap">{{
                targetCustomerMap[1].value || "--"
              }}</span>
              <span>人</span>
            </div>
            <div>
              <span>短信内容</span>
              <span v-if="!homeJump">{{ effectObj.content }}</span>
              <span v-else>{{ homePageData.content }}</span>
            </div>
          </div>
          <div class="info-box" v-if="typeEffect == 5">
              <div>
                <span>状态：</span>
                <span style="margin-right: 50px">已发送</span>

                <span>会员总数：</span>
                <span :style="{ color: globalBG }">{{
                  effectObj.shopBuyerNum
                }}</span>
                <span style="margin-right: 50px">人</span>

                <span>短信费用：</span>
                <span :style="{ color: globalBG }">{{
                  effectObj.totalPrice
                }}</span>
                <span>条</span>
              </div>
              <div>
                <span>短信内容</span>
                <span>{{ effectObj.content }}</span>
              </div>
            </div>
        </div>
        <div class="top-content" v-if="typeEffect == 4">
          <div class="tip-box">
            <i class="el-icon-warning warning-icon"></i>
            <span
              >当日的效果数据会在次日8点后更新，最长可统计30天，请根据实际需要选择日期区间查看效果数据；</span
            >
          </div>
        </div>

        <!-- 统计时间 -->
        <div
          class="statisical-time box-shadow"
          v-if="typeEffect == 1 || typeEffect == 4 || typeEffect == 5"
        >
          <div class="search-box">
            <span>统计时间：</span>
            <el-select
              v-if="typeEffect == 1 || typeEffect == 5"
              v-model="formData.type"
              placeholder="请选择"
              style="width: 140px; margin-right: 12px; vertical-align: top"
              @change="switchType"
            >
              <el-option
                v-for="item in timeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formData.startTime"
                type="date"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formData.endTime"
                type="date"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearTime1()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
            <el-button
              type="primary"
              style="margin-left: 20px"
              @click="handleSearch"
              >查询</el-button
            >
            <el-button @click="reset">重置</el-button>
            <el-button
              style="float: right; margin-right: 30px"
              type="primary"
              @click="exportData"
              >导出数据</el-button
            >
          </div>
          <div class="customer-data">
            <div class="customer-item">
              <div class="customer-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>触达分析</span>
              </div>
              <div class="customer-content">
                <div v-for="(item, index) in targetCustomerMap" :key="index">
                  {{ item.name }}{{ item.value ? item.value : "--"
                  }}{{ item.unit }}
                </div>
              </div>
            </div>
            <div class="customer-item">
              <div class="customer-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>流量分析</span>
              </div>
              <div class="customer-content">
                <div v-for="(item, index) in accessResponseMap" :key="index">
                  {{ item.name
                  }}{{ item.value === 0 || item.value ? item.value : "--"
                  }}{{ item.unit }}
                </div>
              </div>
            </div>
            <div class="customer-item">
              <div class="customer-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>订单分析</span>
              </div>
              <div class="customer-content" style="overflow: auto">
                <div v-for="(item, index) in takeOrderMap" :key="index">
                  {{ item.name
                  }}{{ item.value === 0 || item.value ? item.value : "--"
                  }}{{ item.unit }}
                </div>
              </div>
            </div>
            <!-- <div class="customer-item">
              <div class="customer-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>优惠券分析</span>
              </div>
              <div class="customer-content">
                <div v-for="(item, index) in couponMap" :key="index">
                  {{ item.name }}{{ item.value ? item.value : "--"
                  }}{{ item.unit }}
                </div>
              </div>
            </div> -->
            <div class="customer-item">
              <div class="customer-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>兴趣分析</span>
              </div>
              <div class="customer-content">
                <div v-for="(item, index) in successMap" :key="index">
                  {{ item.name }}{{ item.value ? item.value : "--"
                  }}{{ item.unit }}
                </div>
              </div>
            </div>
            <div class="customer-item">
              <div class="customer-title">
                <span class="division" :style="{ background: globalBG }"></span>
                <span>会员购买分析</span>
              </div>
              <div class="customer-content">
                <div
                  v-for="(item, index) in marketingInsightIntoMap"
                  :key="index"
                >
                  {{ item.name }}{{ item.value ? item.value : "--"
                  }}{{ item.unit }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 商品分析数据 -->
        <div
          class="good-analysis box-shadow"
          v-if="typeEffect == 1 || typeEffect == 4 || typeEffect == 5"
        >
          <div class="tab-line">
            <div
              class="tab-item"
              @click="switchGood('1')"
              :style="{ color: tabGoodIndex == 1 ? globalBG : '' }"
            >
              浏览商品TOP10
              <span
                class="active-line"
                :style="{
                  'background-color': tabGoodIndex == 1 ? globalBG : '',
                }"
              ></span>
            </div>
            <div
              class="tab-item"
              @click="switchGood('2')"
              :style="{ color: tabGoodIndex == 2 ? globalBG : '' }"
            >
              加购商品TOP10
              <span
                class="active-line"
                :style="{
                  'background-color': tabGoodIndex == 2 ? globalBG : '',
                }"
              ></span>
            </div>
            <div
              class="tab-item"
              @click="switchGood('3')"
              :style="{ color: tabGoodIndex == 3 ? globalBG : '' }"
            >
              付款商品TOP10
              <span
                class="active-line"
                :style="{
                  'background-color': tabGoodIndex == 3 ? globalBG : '',
                }"
              ></span>
            </div>
          </div>
          <div class="table-box">
            <el-table
              ref="skuBrowsePvUvTable"
              tooltip-effect="light"
              :data="goodsData"
              show-summary
              :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
              style="width: 100%; border: 1px solid #eee"
              stripe
            >
              <el-table-column label="排行榜" type="index"></el-table-column>
              <el-table-column label="商品">
                <template slot-scope="scope">
                  <div>{{ scope.row.wareName }}</div>
                  <div>skuid:{{ scope.row.skuId }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="PV(次数)"
                prop="pv"
                v-if="tabGoodIndex == 1"
              ></el-table-column>
              <el-table-column
                label="UV(人)"
                prop="uv"
                v-if="tabGoodIndex == 1"
              ></el-table-column>
              <el-table-column
                label="客户数（人）"
                prop="userNum"
                v-if="tabGoodIndex != 1"
              ></el-table-column>
              <el-table-column
                label="件数（件）"
                prop="skuNum"
                v-if="tabGoodIndex != 1"
              ></el-table-column>
              <el-table-column
                label="金额（元）"
                prop="amount"
                v-if="tabGoodIndex == 3"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <send-message-x
        @goBack="showSend = false"
        :sendType="sendType"
        :effectParam="effectParam"
        v-if="showSend"
      ></send-message-x>
    </div>
  </div>
</template>

<script>
import { precisionMore } from "@/api/homePage";
import { getOfficialEffect } from "@/api/smsSend"
import {
  getTaskWithId,
  getAnalyzing,
  getCompareList,
} from "@/api/marketing/batchListSummary";
import {
  getSmsEffectGet,
  exportSmsEffect,
} from "@/api/marketing/precisionMarketing";
import { getEffectMarket } from "@/api/marketing/autoMarketingO";
import { getEffectAnalyze } from "@/api/smsMarketing";
import { updateUnitPrice } from "@/api/sellerController";
import searchTable from "@/components/search-table";
import myEcharts from "@/components/echarts.vue";
import echartsCommon from "@/components/echarts-common.vue";
import sendMessageX from "@/components/send-message-x.vue";
import effectAnalysisX from "@/components/effect-analysis-x.vue";

import { mapState } from "vuex";
export default {
  name: "effectAnalysis",
  computed: {
    ...mapState({
      globalBG: "globalBG",
      roiTip: "roiTip",
    }),
    oUnitPrice(nVal, oVal) {
      return this.$store.getters.loginUserInfo.unitPrice;
    },
  },
  components: {
    searchTable,
    myEcharts,
    echartsCommon,
    sendMessageX,
    effectAnalysisX
  },
  props: {
    typeEffect: {
      type: Number,
      default: 1, // 1.表示精准营销的效果分析，2.表示非精准营销发送页的效果分析 3.表示营销汇总分析页面 4.表示自动化营销（官方） 5.表示会员发送，订单发送的改版后的效果分析
    },
    effectObj: {
      type: Object,
      default: () => {},
    },
    homeJump: {
      // 首页跳转过来的
      type: Boolean,
      default: false,
    },
    sendDay: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      updateState: false,
      unitPrice: "",
      formData: {
        startTime: "",
        endTime: "",
        type: "7",
      },
      tableType1: 1,
      tableType2: 2,
      tableType3: 3,
      timeType: [
        {
          label: "自定义",
          value: "",
        },
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
      ],
      goodsData: [],
      tabGoodIndex: 1,
      tabIndex: 1,
      tabCompIndex: 1,
      tableLoading: false,
      param: {},
      total: 0,
      activityData: [],

      // 精选营销的
      targetCustomerMap: null, // 目标客户
      accessResponseMap: null, // 访问响应客户
      takeOrderMap: null, // 订单分析客户
      successMap: null, // 成交响应客户
      couponMap: null, // 优惠券响应客户
      marketingInsightIntoMap: null, // 营销洞察
      skuBrowsePvUvList: [], // 浏览商品top10
      skuCartList: [], // 加购商品top10
      skuPayList: [], // 付款商品top10
      roi: "",

      smsType: 1, // 官方发送的页面跳转过来为1， 其他页面为2 系统发送
      // 除精准营销之外的其他页面的效果分析
      effectAnalysisData: {
        targetCustomerMap: {}, // 触达分析
        shortLinkAccessMap: {}, // 短链接效果，为空，官方不显示
        takeOrderMap: {}, // 下单分析
        successMap: {}, // 付款分析
        potentialMap: {}, // 意向购买分析
      },
      trendingList: [], // 趋势分析
      taskObj: {}, // 任务数据
      taskId: "", // 任务id
      echartsData: null, // 活动对比分析数据
      batchId: "", // 批次id

      homePageData: {},

      selectForm: {
        x1: "",
        x2: "",
        x3: "",
        x4: "",
        x5: "",
      },
      // 效果分析下拉框选择
      noTakeOrderCustomerCount: 0, // 未下单客户
      targetCMList: [], // 触达分析
      shortLinkList: [], // 短链接效果
      takeOrderList: [], // 下单分析
      payAList: [], // 付款分析
      potentialList: [], // 意向购买分析
      effectParam: {}, // 效果分析发送参数
      sendType: "", // 官方发送统一用会员发送 2， 平台发送的都是用指定号码发送4
      showSend: false,
      isHideSSend: false, // 是否隐藏二次发送
    };
  },
  mounted() {
    console.log("effectObj", this.effectObj);
    this.unitPrice = this.oUnitPrice;
    if (this.homeJump) {
      var sendDay = +this.sendDay;
      var params = {
        days: sendDay,
      };
      precisionMore(params).then((res) => {
        if (res.code == "1") {
          this.homePageData = res.data;
          this.switchType(sendDay);
          this.formData.type = sendDay + "";
          this.getEffectData();
        }
      });
      return;
    }

    if (this.typeEffect == "1") {
      this.switchType(7);
      this.getEffectData();
    } else if (this.typeEffect == "2") {
      // 非精准营销
      this.batchId = this.effectObj.bid;
      if (this.effectObj.smsType == '1') {
        // 官方
        this.isHideSSend = true;
      }
      this.switchType(7);
      this.getEffectDataOthers();
    } else if (this.typeEffect == "3") {
      // 营销效果汇总分析
      this.isHideSSend = true;
      this.taskId = this.effectObj.id;
      this.getEffectTotal();
    } else if (this.typeEffect == "4") {
      // 自动化营销（官方）
      // this.formData.startTime = this.effectObj.activityStartTime;
      var startTime = this.switchTypeDate(-30);
      if (new Date(this.effectObj.activityStartTime).getTime() > new Date(startTime).getTime()) {
        startTime = this.effectObj.activityStartTime;
      }
      this.formData.startTime = startTime;
      // this.formData.endTime = this.effectObj.activityEndTime;
      this.formData.endTime = this.switchTypeDate(0);
      // this.switchType(30);
      this.getEffectMarketO();
    } else if (this.typeEffect == '5') {
      // 订单发送，会员发送的新版效果分析
      this.switchType(7); 
      this.getEffectDataSending();
    }
  },
  filters: {
    showStatusStr(num) {
      var result = "";
      if (num == "1") {
        result = "待审核";
      } else if (num == "3") {
        result = "审核通过";
      } else if (num == "4") {
        result = "审核未通过";
      } else if (num == "5") {
        result = "已取消";
      } else if (num == "100") {
        result = "发送中";
      } else if (num == "101") {
        result = "已发送";
      } else if (num == "102") {
        result = "发送失败";
      }
      return result;
    },
  },
  methods: {
     getEffectDataSending() {
      // 获取订单发送，会员发送的新版效果分析的数据
      var param = {
          // activityRecordId: this.effectObj.activityRecordId,
          id: this.effectObj.bid,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
        };

      getOfficialEffect(param).then((res) => {
        // 精准营销
        if (res.code == "1") {
          this.encapEffect(res);
        }
      });
    },
    // 精准营销，自动化营销（官方）订单，会员发送新版 查询
    handleSearch() {
      if (this.typeEffect == '4') {
        this.getEffectMarketO()
      } else if (this.typeEffect == '1'){
        this.getEffectData();
      } else if (this.typeEffect == '5') {
        this.getEffectDataSending();
      }
    },
    handleClick(item) {
      // console.log('handleClick')
      if (item.num > 0) {
        var val = item.value;
        this.changeType1(val);
      }
    },
    // 触达分析发送短信
    changeType1(val) {
      console.log(val);
      var sendParam = {
        effectSelect: this.effectSelect,
        sendObjectType: val,
        typeIndex: this.effectObj.typeIndex,
        isOfficial: this.effectObj.isOfficial,
      };
      if (this.typeEffect == "3") {
        sendParam.taskId = this.effectObj.id;
      }
      if (this.typeEffect == "2") {
        sendParam.bid = this.effectObj.bid;
      }
      // 活动类型官方的短链接相关选项禁止勾选
      if (this.effectObj.isOfficial) {
        sendParam.effectSelect.forEach((item, index) => {
          if (index >= 1 && index <= 8) {
            item.num = 0;
          }
        });
      }

      this.effectParam = sendParam;
      if (this.effectObj.typeIndex != "3" && this.effectObj.typeIndex != "4") {
        this.sendType = 2;
      } else {
        // 非指定号码，变量
        this.sendType = 4; // send-message-x 4.指定号码 5.变量短信
      }

      console.log("sendParam:", sendParam);
      this.showSend = true;
    },

    updateROI() {
      if (this.updateState) {
        updateUnitPrice(this.effectObj.smsType == 1 ? 1 : 0, this.unitPrice).then((res) => {
          if (res.code == "1") {
            this.$message.success("修改成功！");
            // 刷新roi
            if (this.typeEffect == "1") {
              this.getEffectData();
            } else if (this.typeEffect == "2") {
              // 非精准营销
              this.getEffectDataOthers();
            } else if (this.typeEffect == "3") {
              // 营销效果汇总分析
              this.getEffectTotal();
            } else if (this.typeEffect == '5') {
              // 会员发送，订单发送新数据
              this.getEffectDataSending();
            }
          } else {
            this.$message.error(res.message);
          }
        });
      }
      this.updateState = !this.updateState;
    },

    // 精准营销数据导出
    exportData() {
      var param = "";
      if (this.homeJump) {
        // 首页跳转过来的
        param = {
          // activityRecordId: this.effectObj.activityRecordId,
          strategyInstId: this.homePageData.strategyInstId,
          id: this.homePageData.id,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
          activityTitle: this.homePageData.activityTitle,
          content: this.homePageData.content,
          sendSubmitNum: this.homePageData.sendSubmitNum,
        };
      } else if (this.typeEffect == "4") {
          // 自动化营销（官方）
          param = {
            startTime: this.formData.startTime,
            endTime: this.formData.endTime,
            id: this.effectObj.id
          }
      } else if (this.typeEffect == '5') {
        // 订单，会员发送新版
        param = {
          id: this.effectObj.bid,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
        }
      } else {
        // 精准营销的
        param = {
          // activityRecordId: this.effectObj.activityRecordId,
          strategyInstId: this.effectObj.strategyInstId,
          id: this.effectObj.id,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
          activityTitle: this.effectObj.activityTitle,
          content: this.effectObj.content,
          sendSubmitNum: this.effectObj.sendSubmitNum,
        };
      }

      var paramStr = "";
      for (var key in param) {
        var temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);

      let elem = document.createElement("a");
      elem.style.display = "none";
      
      let url = "/jd-yusms/precisionMarketing/exportSmsEffect?" + paramStr;
      if (this.typeEffect == "4") {
        // 自动化营销（官方）
        url = "/jd-yusms/autoMarketing/effect/export?" + paramStr;
      } else if (this.typeEffect == '5') {
        // 订单，会员发送 新版
         url = "/jd-yusms/sms/official/effect/export?" + paramStr;
      }
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);

      // exportSmsEffect(param).then((res) => {
      //   console.log(res);
      // });
    },
    resetDataOthers() {
      this.formData.type = "7";
      this.switchType(7);
      this.getEffectDataOthers();
    },
    reset() {
      this.formData.type = "7";
      this.switchType("7");
      if (this.typeEffect == 1) {
        this.getEffectData();
      } else if (this.typeEffect == 5) {
        this.getEffectDataSending();
      }
      
    },
    switchGood(index) {
      this.tabGoodIndex = index;
      if (index == 1) {
        this.goodsData = this.skuBrowsePvUvList;
      } else if (index == 2) {
        this.goodsData = this.skuCartList;
      } else if (index == 3) {
        this.goodsData = this.skuPayList;
      }
    },
    getEffectTotal() {
      // 获取任务信息
      console.log(this.effectObj);
      var id = this.effectObj.id;
      getTaskWithId(id).then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.taskObj = res.data;
        }
      });
      this.getEffectDataAll();
    },
    // 自动化营销（官方）获取效果分析
    getEffectMarketO() {
      var param = {
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
        id: this.effectObj.id,
      };
      getEffectMarket(param).then((res) => {
        this.encapEffect(res);
      });
    },
    // 汇总分析获取效果分析
    getEffectDataAll() {
      var id = this.effectObj.id;
      getAnalyzing(id).then((res) => {
        if (res.code == "1") {
          var data = res.data;
          this.trendingList = data.trendAnalysisVOList;
          this.setMarketingDataTotal(data);
          this.initSelectList();
        }
      });
    },
    // 所有分析的下拉列表赋值
    initSelectList() {
      var comObj = {
        label: "发送短信",
        value: "",
        num: "",
      };
      // 触达分析
      this.targetCMList = [];
      // 短链接效果

      this.effectSelect = [
        {
          label: "实际触达人数",
          value: "1",
          num: this.effectAnalysisData.targetCustomerMap[1].value,
        },
        {
          label: "已点击客户",
          value: "2",
          num: this.effectAnalysisData.shortLinkAccessMap[1].value,
        },
        {
          label: "未点击客户",
          value: "3",
          num: this.effectAnalysisData.shortLinkAccessMap[2].value,
        },
        {
          label: "短链接未点击未下单",
          value: "4",
          num: this.effectAnalysisData.shortLinkAccessMap[3].value,
        },
        {
          label: "短链接已点击未下单",
          value: "5",
          num: this.effectAnalysisData.shortLinkAccessMap[4].value,
        },
        {
          label: "短链接已点击已下单",
          value: "6",
          num: this.effectAnalysisData.shortLinkAccessMap[5].value,
        },
        {
          label: "短链接已点击已付款",
          value: "7",
          num: this.effectAnalysisData.shortLinkAccessMap[6].value,
        },
        {
          label: "短链接已点击已下单未付款",
          value: "8",
          num: this.effectAnalysisData.shortLinkAccessMap[8].value,
        },
        {
          label: "下单客户",
          value: "9",
          num: this.effectAnalysisData.takeOrderMap[0].value,
        },
        {
          label: "未下单客户",
          value: "10",
          num: this.noTakeOrderCustomerCount,
        },
        {
          label: "付款客户",
          value: "11",
          num: this.effectAnalysisData.successMap[0].value,
        },
        {
          label: "意向购买客户",
          value: "12",
          num: this.effectAnalysisData.potentialMap[0].value,
        },
      ];
      this.targetCMList = [comObj, this.effectSelect[0]];
      this.shortLinkList = [comObj].concat(this.effectSelect.slice(1, 8));
      this.takeOrderList = [comObj].concat(this.effectSelect.slice(8, 10));
      this.payAList = [comObj, this.effectSelect[10]];
      this.potentialList = [comObj, this.effectSelect[11]];
    },

    // 将获取的数据封装修改，显示到页面上， 营销汇总分析
    setMarketingDataTotal(data) {
      var dataA = data.targetCustomersVO || {}; // 触达分析
      var dataB = data.shortLinkAccessMap || {}; // 短链接效果 -1
      var dataC = data.takeOrderCustomersVO || {}; // 下单分析
      var dataD = data.successCustomersVO || {}; // 付款分析
      var dataE = data.intentionalCustomersVO || {}; // 意向购买分析

      this.roi = dataA.roiRate;
      this.noTakeOrderCustomerCount = dataC.noTakeOrderCustomerCount;

      var targetRate = "";
      if (dataA.targetCustomerCount && dataA.submitCustomerCount) {
        targetRate =
          (Number(dataA.targetCustomerCount) /
            Number(dataA.submitCustomerCount).toFixed(2)) *
          100;
      }
      this.effectAnalysisData.targetCustomerMap = [
        {
          name: "预计触达人数：",
          value: dataA.submitCustomerCount,
          unit: "人",
        },
        {
          name: "实际触达人数：",
          value: dataA.targetCustomerCount,
          unit: "人",
        },
        {
          name: "触达率：",
          value: targetRate,
          unit: "%",
        },
        {
          name: "短信使用量：",
          value: dataA.useCount,
          unit: "条",
        },
      ];

      this.effectAnalysisData.shortLinkAccessMap = [
        {
          name: "点击PV：",
          value: dataA.shortLinkClickAccessNum
            ? dataA.shortLinkClickAccessNum
            : dataA.clickCount,
          unit: "次",
        },
        {
          name: "点击UV：",
          value: dataA.shortLinkClickAccessNum,
          unit: "人",
        },
        {
          name: "未点击人数：",
          value: dataA.shortLinkNoClickAccessNum,
          unit: "人",
        },
        {
          name: "短链接未点击未下单人数：", // -1 start
          value: dataC.noTakeOrderCustomerShortLinkNoClickCount,
          unit: "人",
        },
        {
          name: "短链接已点击未下单人数：",
          value: dataC.noTakeOrderCustomerShortLinkClickCount,
          unit: "人",
        },
        {
          name: "短链接已点击已下单人数：",
          value: dataC.takeOrderCustomerShortLinkClickCount,
          unit: "人",
        },
        {
          name: "短链接已点击已付款人数：",
          value: dataC.takeOrderPayCustomerShortLinkClickCount,
          unit: "人",
        },
        {
          name: "短链接已点击已付款金额：",
          value: dataC.totalMoney,
          unit: "元",
        },
        {
          name: "短链接已点击已下单未付款人数：", // -1 end
          value: dataC.takeOrderNoPayCustomerShortLinkClickCount,
          unit: "人",
        },
      ];

      this.effectAnalysisData.takeOrderMap = [
        {
          name: "下单人数：",
          value: dataC.takeOrderCustomerCount,
          unit: "人",
        },
        {
          name: "下单订单数：",
          value: dataC.takeOrderCount,
          unit: "单",
        },
        {
          name: "下单金额：",
          value: dataC.takeOrderMoneyCount,
          unit: "元",
        },
        {
          name: "下单件数：",
          value: dataC.takeItemCount,
          unit: "件",
        },
        {
          name: "客单价：",
          value: dataC.pinAveragePice,
          unit: "元",
        },
        {
          name: "商品均价：",
          value: dataC.itemAveragePice,
          unit: "元",
        },
        {
          name: "订单均价：",
          value: dataC.averagePice,
          unit: "元",
        },
        {
          name: "人均下单商品数：",
          value: dataC.pinAverageItem,
          unit: "件",
        },
      ];

      this.effectAnalysisData.successMap = [
        {
          name: "付款人数：",
          value: dataD.successCustomerCount,
          unit: "人",
        },
        {
          name: "付款订单数：",
          value: dataD.successOrderCount,
          unit: "单",
        },
        {
          name: "付款金额：",
          value: dataD.successMoneyCount,
          unit: "元",
        },
        {
          name: "付款件数：",
          value: dataD.successItemCount,
          unit: "件",
        },
        {
          name: "客单价：",
          value: dataD.pinAveragePice,
          unit: "元",
        },
        {
          name: "商品均价：",
          value: dataD.itemAveragePice,
          unit: "元",
        },
        {
          name: "订单均价：",
          value: dataD.averagePice,
          unit: "元",
        },
        {
          name: "人均付款商品数：",
          value: dataD.pinAverageItem,
          unit: "件",
        },
      ];

      this.effectAnalysisData.potentialMap = [
        {
          name: "意向购买人数：",
          value: dataE.intentionalCustomerCount,
          unit: "人",
        },
        {
          name: "未付款订单数：",
          value: dataE.intentionalOrderCount,
          unit: "单",
        },
        {
          name: "意向购买商品总数：",
          value: dataE.intentionalItemCount,
          unit: "件",
        },
        {
          name: "人均意向购买件数：",
          value: dataE.pinAverageItem,
          unit: "件",
        },
      ];
    },

    getEffectDataOthers() {
      // 获取除精准营销外其他页面的效果分析
      var param = {
        batchId: this.effectObj.bid,
        smsType: this.effectObj.smsType, // 2.系统（变量,指定号码短信发送页面） 1. 官方
        orderStartTimeStart: this.formData.startTime + " 00:00:00", // "2020-03-28 19:01:00"
        orderStartTimeEnd: this.formData.endTime + " 00:00:00", //  "2020-04-04 19:01:00"
      };
      getEffectAnalyze(param).then((res) => {
        if (res.code == "1") {
          console.log(res);
          this.trendingList = res.data.trendingList;
          console.log("res.data.trendingList:", res.data.trendingList);
          this.setMarketingData(res.data);
          this.initSelectList();
        }
      });
    },

    // 将获取的数据封装修改，显示到页面上
    setMarketingData(data) {
      var dataA = data.targetCustomerMap || {}; // 触达分析
      var dataB = data.shortLinkAccessMap || {}; // 触达分析
      var dataC = data.takeOrderMap || {}; // 下单分析
      var dataD = data.successMap || {}; // 付款分析
      var dataE = data.potentialMap || {}; // 意向购买分析

      var useTotal = this.effectObj.totalPrice;
      var buyedMoneyTotal = dataD.totalPayment;
      this.noTakeOrderCustomerCount =
        dataA.targetCustomersCount - dataC.totalPayment;

      var roi = "";
      if (!(useTotal === null || useTotal === undefined)) {
        roi =
          useTotal == 0
            ? useTotal + " : " + this.changeTwoDecimal_f(buyedMoneyTotal)
            : 1 +
              " : " +
              Math.round(
                (1 / (useTotal * this.unitPrice)) * buyedMoneyTotal * 100
              ) /
                100;
      }

      this.roi = roi;

      var targetRate = "";
      if (dataA.realSendCount && dataA.targetCustomersCount) {
        targetRate =
          (Number(dataA.realSendCount) /
            Number(dataA.targetCustomersCount)*100).toFixed(2);
      }
      this.effectAnalysisData.targetCustomerMap = [
        {
          name: "预计触达人数：",
          value: dataA.targetCustomersCount,
          unit: "人",
        },
        {
          name: "实际触达人数：",
          value: dataA.realSendCount,
          unit: "人",
        },
        {
          name: "触达率：",
          value: targetRate,
          unit: "%",
        },
        {
          name: "短信使用量：",
          value: dataA.useCount,
          unit: "条",
        },
      ];

      this.effectAnalysisData.shortLinkAccessMap = [
        {
          name: "点击PV：",
          value: dataB.shortLinkClickNum,
          unit: "次",
        },
        {
          name: "点击UV：",
          value: dataB.shortLinkClickAccessNum,
          unit: "人",
        },
        {
          name: "未点击人数：",
          value: dataB.shortLinkNoClickAccessNum,
          unit: "人",
        },
        {
          name: "短链接未点击未下单人数：",
          value: dataB.notClickNotTakeOrderPinNum,
          unit: "人",
        },
        {
          name: "短链接已点击未下单人数：",
          value: dataB.clickNotTakeOrderPinNum,
          unit: "人",
        },
        {
          name: "短链接已点击已下单人数：",
          value: dataB.clickTakeOrderPinNum,
          unit: "人",
        },
        {
          name: "短链接已点击已付款人数：",
          value: dataB.clickTakeOrderPayPinNum,
          unit: "人",
        },
        {
          name: "短链接已点击已付款金额：",
          value: dataB.clickTakeOrderPayment,
          unit: "元",
        },
        {
          name: "短链接已点击已下单未付款人数：",
          value: dataB.clickTakeOrderNotPayPinNum,
          unit: "人",
        },
      ];

      this.effectAnalysisData.takeOrderMap = [
        {
          name: "下单人数：",
          value: dataC.totalPin,
          unit: "人",
        },
        {
          name: "下单订单数：",
          value: dataC.totalOrder,
          unit: "单",
        },
        {
          name: "下单金额：",
          value: dataC.totalPayment,
          unit: "元",
        },
        {
          name: "下单件数：",
          value: dataC.totalItems,
          unit: "件",
        },
        {
          name: "客单价：",
          value: dataC.pinAveragePrice,
          unit: "元",
        },
        {
          name: "商品均价：",
          value: dataC.itemAveragePrice,
          unit: "元",
        },
        {
          name: "订单均价：",
          value: dataC.orderAverage,
          unit: "元",
        },
        {
          name: "人均下单商品数：",
          value: dataC.pinAverageItem,
          unit: "件",
        },
      ];

      this.effectAnalysisData.successMap = [
        {
          name: "付款人数：",
          value: dataD.totalPin,
          unit: "人",
        },
        {
          name: "付款订单数：",
          value: dataD.totalOrder,
          unit: "单",
        },
        {
          name: "付款金额：",
          value: dataD.totalPayment,
          unit: "元",
        },
        {
          name: "付款件数：",
          value: dataD.totalItems,
          unit: "件",
        },
        {
          name: "客单价：",
          value: dataD.pinAveragePrice,
          unit: "元",
        },
        {
          name: "商品均价：",
          value: dataD.itemAveragePrice,
          unit: "元",
        },
        {
          name: "订单均价：",
          value: dataD.orderAverage,
          unit: "元",
        },
        {
          name: "人均付款商品数：",
          value: dataD.pinAverageItem,
          unit: "件",
        },
      ];

      this.effectAnalysisData.potentialMap = [
        {
          name: "意向购买人数：",
          value: dataE.totalPin,
          unit: "人",
        },
        {
          name: "未付款订单数：",
          value: dataE.totalOrder,
          unit: "单",
        },
        {
          name: "意向购买商品总数：",
          value: dataE.totalItems,
          unit: "件",
        },
        {
          name: "人均意向购买件数：",
          value: dataE.totalItems / dataE.totalPin || "0",
          unit: "件",
        },
      ];
    },

    getEffectData() {
      // 获取精准营销的效果分析的数据
      var param = {};
      if (!this.homeJump) {
        param = {
          // activityRecordId: this.effectObj.activityRecordId,
          strategyInstId: this.effectObj.strategyInstId,
          id: this.effectObj.id,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
        };
      } else {
        // 首页跳转过来的
        param = {
          // activityRecordId: this.effectObj.activityRecordId,
          strategyInstId: this.homePageData.strategyInstId,
          id: this.homePageData.id,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
        };
      }

      getSmsEffectGet(param).then((res) => {
        // 精准营销
        if (res.code == "1") {
          this.encapEffect(res);
          // console.log(this.accessResponseMap)
        }
      });
    },

    // 封装精准营销，跟营销效果分析（汇总的数据）
    encapEffect(res) {
      this.skuBrowsePvUvList = res.data.skuBrowsePvUvList || [];
      this.skuCartList = res.data.skuCartList || [];
      this.skuPayList = res.data.skuPayList || [];
      this.goodsData = this.skuBrowsePvUvList;
      this.roi = res.data.roi;

      var a = res.data.targetCustomerMap || {};
      var b = res.data.accessResponseMap || {};
      // var c = res.data.takeOrderMap || {};
      var c = res.data.successMap || {};
      var d = res.data.interestAnalyseMap || {};
      var e = res.data.couponMap || {};
      var g = res.data.marketingInsightIntoMap || {};
      var targetRate = "";
      if (a.peopleSentNum && a.deliveredNum) {
        targetRate =
          (Number(a.deliveredNum) / Number(a.peopleSentNum)).toFixed(2) * 100;
      }
       this.targetCustomerMap = [
          {
            name: "预计触达人数：",
            value: a.peopleSentNum,
            unit: "人",
          },
          {
            name: "实际触达人数：",
            value: a.deliveredNum,
            unit: "人",
          },
          {
            name: "触达率：",
            value: targetRate,
            unit: "%",
          },
      ];
     
      this.accessResponseMap = [
        {
          name: "短链点击PV：",
          value: b.pv,
          unit: "次",
        },
        {
          name: "短链访点击UV：",
          value: b.uv,
          unit: "人",
        },
        {
          name: "商品详情页PV：",
          value: b.skuPvNum,
          unit: "",
        },
        {
          name: "商品详情页UV：",
          value: b.skuUvNum,
          unit: "",
        },
        {
          name: "店铺首页PV：",
          value: b.shopPvNum,
          unit: "",
        },
        {
          name: "店铺首页UV：",
          value: b.shopUvNum,
          unit: "",
        },
      ];
      this.takeOrderMap = [
        {
          name: "下单人数：",
          value: c.ordPins,
          unit: "人",
        },
        {
          name: "下单金额：",
          value: c.ordAmount,
          unit: "元",
        },
        {
          name: "下单订单数：",
          value: c.ordNum,
          unit: "单",
        },
        {
          name: "下单件数：",
          value: c.ordQtty,
          unit: "件",
        },
        {
          name: "下单-付款转化率：",
          value: Number(c.payRate * 100).toFixed(2),
          unit: "%",
        },

        {
          name: "付款人数：",
          value: c.payPins,
          unit: "人",
        },
        {
          name: "付款金额：",
          value: c.payAmount,
          unit: "元",
        },
        {
          name: "付款订单数：",
          value: c.payNum,
          unit: "单",
        },
        {
          name: "付款件数：",
          value: c.payQtty,
          unit: "件",
        },
      ];
      this.successMap = [
        {
          name: "关注商品人数：",
          value: d.followSkuNum,
          unit: "人",
        },
        {
          name: "关注店铺人数：",
          value: d.followShopNum,
          unit: "人",
        },
        {
          name: "加购人数：",
          value: d.cartNum,
          unit: "人",
        },
      ];
      this.couponMap = [
        {
          name: "领劵响应率：",
          value: e.couponResponseRate,
          unit: "",
        },
        {
          name: "领劵人数：",
          value: e.couponPins,
          unit: "人",
        },
        {
          name: "用劵人数：",
          value: e.couponUsePins,
          unit: "人",
        },
        {
          name: "优惠劵引入订单：",
          value: e.couponOrders,
          unit: "单",
        },
        {
          name: "优惠劵引入金额：",
          value: e.couponAmount,
          unit: "元",
        },
      ];
      this.marketingInsightIntoMap = [
        {
          name: "已购会员购买客户数：",
          value: g.memberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买客户数：",
          value: g.brandMemberBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买客户数：",
          value: g.cardMemberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买新客户数：",
          value: g.brandMemberNewbuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买新客户数：",
          value: g.cardMemberNewbuyPins,
          unit: "人",
        },
      ];
    },

    switchType(val) {
      if (val) {
        var startTime = "";
        if (this.homeJump) {
          startTime = this.homePageData.effectTime.substr(0, 10);
        } else {
          startTime = this.effectObj.sendTime.substr(0, 10);
        }

        this.formData.startTime = startTime;

        var dd = new Date(startTime);
        dd.setDate(dd.getDate() + +val);
        var y = dd.getFullYear();
        var m =
          dd.getMonth() + 1 < 10
            ? "0" + (dd.getMonth() + 1)
            : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        var endTime = y + "-" + m + "-" + d;
        this.formData.endTime = endTime;
      }
    },
    switchTypeDate(val) {
      // if (val) {
        var dd = new Date();
        dd.setDate(dd.getDate() + +val);
        var y = dd.getFullYear();
        var m =
          dd.getMonth() + 1 < 10
            ? "0" + (dd.getMonth() + 1)
            : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        var result = y + "-" + m + "-" + d;
        return result;
      // }
    },
    goBack() {
      this.$emit("onClose", false);
    },
    handleSwitch(val) {
      this.tabIndex = val;
      if (val == "1") {
        // 效果分析
        if (this.typeEffect == "2") {
          this.getEffectDataOthers();
        } else {
          // 汇总分析的
          this.getEffectDataAll();
        }
      } else if (val == "2") {
        // 活动对比
        var id = this.taskId;
        this.tableLoading = true;
        getCompareList(id).then((res) => {
          console.log(res);
          this.tableLoading = false;
          if (res.code == "1") {
            this.activityData = res.data;
            this.handleCompSwitch(1);
          }
        });
      }
    },
    handleCompSwitch(val) {
      this.tabCompIndex = val;
      var echartsData = {};
      var xDateList = [];
      var nameList = [];
      var intentionalCustomerCount = []; // 意向客户数
      var takeOrCusList = []; // 拍单客户数
      var successCustomerCount = []; // 成交客户数

      // var intCusCountList = []; // 意向客金额
      var takeOrderMoneyCount = []; // 拍单金额
      var successMoneyCount = []; // 成交金额

      var intentionalItemCount = []; // 意向商品数
      var takeItemCount = []; // 拍单商品数
      var successItemCount = []; // 成交商品数

      var intentionalResponseRate = []; // 意向响应率
      var takeOrderResponseRate = []; // 拍单响应率
      var successResponseRate = []; // 成交响应率

      this.activityData.forEach((item) => {
        xDateList.push(item.smsTitle); // 标题
        intentionalCustomerCount.push(item.intentionalCustomerCount);
        takeOrCusList.push(item.takeOrCusList);
        successCustomerCount.push(item.successCustomerCount);

        // intCusCountList.push(item.intentionalCustomerCount);
        takeOrderMoneyCount.push(item.takeOrderMoneyCount);
        successMoneyCount.push(item.successCustomerCount);

        intentionalItemCount.push(item.intentionalItemCount);
        takeItemCount.push(item.takeItemCount);
        successItemCount.push(item.successItemCount);

        if (item.intentionalResponseRate.indexOf("%") != "-1") {
          item.intentionalResponseRate = item.intentionalResponseRate.replace(
            /%/,
            ""
          );
        }
        if (item.takeOrderResponseRate.indexOf("%") != "-1") {
          item.takeOrderResponseRate = item.takeOrderResponseRate.replace(
            /%/,
            ""
          );
        }
        if (item.successResponseRate.indexOf("%") != "-1") {
          item.successResponseRate = item.successResponseRate.replace(/%/, "");
        }
        intentionalResponseRate.push(item.intentionalResponseRate);
        takeOrderResponseRate.push(item.takeOrderResponseRate);
        successResponseRate.push(item.successResponseRate);
      });

      if (val == "1") {
        // 客户数量分析
        nameList = ["意向客户数", "拍单客户数", "成交客户数"];
        echartsData = {
          list1: intentionalCustomerCount,
          list2: takeOrCusList,
          list3: successCustomerCount,
        };
      } else if (val == "2") {
        // 订单金额分析
        nameList = ["意向客金额", "拍单金额", "成交金额"];
        echartsData = {
          list1: [],
          list2: takeOrderMoneyCount,
          list3: successMoneyCount,
        };
      } else if (val == "3") {
        // 商品数据分析
        nameList = ["意向商品数", "拍单商品数", "成交商品数"];
        echartsData = {
          list1: intentionalItemCount,
          list2: takeItemCount,
          list3: successItemCount,
        };
      } else if (val == "4") {
        // 响应率分析
        nameList = ["意向响应率", "拍单响应率", "成交响应率"];
        echartsData = {
          list1: intentionalResponseRate,
          list2: takeOrderResponseRate,
          list3: successResponseRate,
        };
      }
      echartsData.xDateList = xDateList;
      echartsData.nameList = nameList;
      this.echartsData = echartsData;
    },
    changeTwoDecimal_f(x) {
      var f_x = parseFloat(x);
      if (isNaN(f_x)) {
        console.error("function:changeTwoDecimal->parameter error");
        return false;
      }
      var f_x = Math.round(x * 100) / 100;
      var s_x = f_x.toString();
      var pos_decimal = s_x.indexOf(".");
      if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += ".";
      }
      while (s_x.length <= pos_decimal + 2) {
        s_x += "0";
      }
      return s_x;
    },

    clearTime1() {},
    aaaa() {},
    handleSizeChange() {},
    handleCurrentChange() {},
  },
};
</script>

<style lang="scss" scoped>
.price-input {
  display: inline-block;
  width: 140px;
  margin: 0 20px;
}
.update {
  cursor: pointer;
  color: #7f85e9;
  &:hover{
    color: rgb(254, 77, 69) ;
  }
}

/**  公共部分样式 */
.customer-data {
  padding-top: 30px;
  .customer-item {
    display: inline-block;
    margin-right: 33px;
    margin-bottom: 20px;
    width: 240px;
    vertical-align: text-top;
    border: 1px solid rgba(243, 244, 247, 1);
    &:last-child {
      margin-right: 0;
    }
    .customer-title {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
      background-color: #f3f4f7;
      .division {
        display: inline-block;
        width: 4px;
        height: 22px;
        margin-right: 20px;
      }
      span {
        vertical-align: middle;
      }
    }
    .customer-content {
      height: 244px;
      box-sizing: border-box;
      padding: 24px 20px 0 20px;
      div {
        margin-bottom: 10px;
        font-size: 14px;
        color: #333;
      }
    }
  }
}
.comment-title {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  background-color: #f3f4f7;
  .division {
    display: inline-block;
    width: 4px;
    height: 22px;
    margin-right: 20px;
  }
  span {
    vertical-align: middle;
  }
}
.tab-line-com {
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #dddddd;
  margin: 20px 28px 0 28px;
  .tab-item {
    // padding: 15px 0;
    text-align: center;
    width: 106px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 2px;
    border: 1px solid #dddddd;
    border-bottom: none;
    // &:first-child{
    //   margin-right: 22px;
    // }
    span {
      position: absolute;
      width: 100%;
      left: 50%;
      height: 2px;
      transform: translateX(-50%);
      bottom: -2px;
      display: none;
    }
    &.active {
      border-top: 2px;
      span {
        display: block;
        background: #fff;
      }
    }
  }
}
/** 公共样式end */

.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-top: 12px;
  color: #999999;
  background: #fafafa;
  position: relative;
  margin: 20px 0 16px 0;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}
.effect-analysis {
  padding: 11px 20px;
  .top-box {
    padding-bottom: 30px;
    .nav-box {
      height: 54px;
      line-height: 54px;
      border-bottom: 1px solid #f0f0f0;
      padding-left: 27px;
      .go-back {
        font-size: 14px;
        color: #999999;
        vertical-align: middle;
        cursor: pointer;
        &:hover{
          color: #fe4d45;
        }
      }
      .question_icon {
        width: 14px;
        height: 14px;
        color: #ccc;
        display: inline-block;
        line-height: 12px;
        text-align: center;
        border-radius: 14px;
        border: 1px solid #ccc;
        font-size: 12px;
        font-weight: normal;
      }
      .question_icon:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
      }
      .division {
        display: inline-block;
        vertical-align: middle;
        margin: 0 20px;
        width: 1px;
        height: 20px;
        background: #cccccc;
      }
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #2e3458;
        vertical-align: middle;
        margin-right: 60px;
      }
      .roi {
        font-size: 14px;
        color: #333;
      }
      .num {
        color: rgb(254, 77, 69);
        font-size: 14px;
      }
      .update {
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .effect-content-x {
      font-size: 14px;
      color: #333;
      .tab1-box {
        padding: 20px 28px 0 28px;
        .activity-content {
          border-bottom: 1px solid #f0f0f0;
          padding-bottom: 15px;

          .data-content {
            padding-top: 20px;
            .data-item {
              margin-bottom: 16px;
              .data-label {
                display: inline-block;
                vertical-align: top;
                width: 118px;
                text-align: right;
              }
              .data-value {
                display: inline-block;
                padding-left: 8px;
              }
            }
          }
        }
        .customer-data {
          .customer-item {
            width: 300px;
            .customer-content {
              height: 268px;
              div {
                margin-bottom: 12px;
              }
            }
            .select-box {
              text-align: center;
              margin-bottom: 20px;
            }
          }
        }
      }
      .tab2-box {
        padding: 20px 28px;
        .table-box {
        }
        .comp-analysis {
          margin-top: 30px;
          margin-bottom: 20px;
          .tab-line-com {
            .tab-item {
              width: 106px;
            }
          }
        }
      }
      .tab3-box {
        padding: 20px 28px;
      }
    }
    .top-content {
      margin: 0 28px;
      .info-box {
        border: 1px solid rgba(238, 238, 238, 1);
        padding: 20px;
        border-radius: 4px;
        color: #333333;
        font-size: 14px;
        div:first-child {
          margin-bottom: 16px;
        }
      }
    }
  }
  .statisical-time {
    margin: 20px 0;
    padding: 24px 28px 30px 28px;
  }
  .good-analysis {
    margin-top: 20px;
    padding: 0 28px 30px 28px;
    .tab-line {
      margin-bottom: 20px;
      border-bottom: 1px solid #f6f6f6;
      .tab-item {
        display: inline-block;
        margin-right: 22px;
        padding: 16px 0;
        font-size: 14px;
        color: #999;
        cursor: pointer;
        position: relative;
        .active-line {
          position: absolute;
          width: 100%;
          height: 2px;
          left: 0;
          bottom: -1px;
        }
      }
    }
  }
}
.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
</style>

